module.exports = __webpack_public_path__ + "static/media/Art.7aa419af.png";